export { default } from "./AdminConsoleFacultyAdderUserSection";
